import { gql } from 'apollo-boost';

export const GET_BOOMER_ITEMS = gql`
    query boomerItems($published: Boolean, $archived: Boolean) {
        avatarItems(published: $published, archived: $archived) {
            id
            name
            gender
            price
            published
            type
            url
            xmlId
            xOffset
            yPos
        }
    }
`;

export const GET_S3_UPLOAD_QUERY = gql`
    query s3UploadUrlFor($name: String, $fileType: String, $object: String!) {
        s3UploadUrlFor(name: $name, fileType: $fileType, object: $object) {
            name
            uploadUrl
        }
    }
`;

export const CREATE_AVATAR_ITEM = gql`
    mutation createAvatarItem($name: String!, $itemType: Int!, $gender: Int!, $accessType: Int!, $tiles: Int!,
        $photoUrls: [String!], $yPos: Int, $xOffset: Int, $tileHeight: Int, $price: Float, $published: Boolean, $specialStoreOpeningId: ID) {
            createAvatarItem(name: $name, itemType: $itemType, gender: $gender, accessType: $accessType,
            tiles: $tiles, photoUrls: $photoUrls, yPos: $yPos, xOffset: $xOffset, tileHeight: $tileHeight, price: $price, published: $published, specialStoreOpeningId: $specialStoreOpeningId) {
                avatarItem {
                    id
                    name
                    gender
                    price
                    published
                    type
                    url
                    xmlId
                    xOffset
                    yPos
                }
                errors
            }
        }
`;

export const CREATE_SPECIAL_STORE_OPENING = gql`
    mutation createSpecialStoreOpening($startDate: String!, $endDate: String!) {
        createSpecialStoreOpening(startDate: $startDate, endDate: $endDate) {
            specialStoreOpening {
                id
                startDate
                endDate
            }
            errors
        }
    }
`;

export const GET_SPECIAL_STORE_OPENINGS = gql`
    query specialStoreOpenings {
        specialStoreOpening {
            id
            startDate
            endDate
            avatarItems {
                id
                name
                gender
                type
                price
                url
                photoUrls
                tiles
                xOffset
                yPos
            }
        }
    }
`;

export const EDIT_SPECIAL_STORE_OPENING = gql`
    mutation editSpecialStoreOpening($specialStoreOpeningId: ID!, $startDate: String!, $endDate: String!) {
        editSpecialStoreOpening(specialStoreOpeningId: $specialStoreOpeningId, startDate: $startDate, endDate: $endDate) {
            specialStoreOpening { id startDate endDate }
            errors
        }
    }
`;

export const EDIT_AVATAR_ITEM = gql`
    mutation editAvatarItem($avatarItemId: ID!, $name: String!, $itemType: Int!, $gender: Int!, $price: Float!, $xOffset: Int!, $yPos: Int!, $tiles: Int, $photoUrls: [String!], $published: Boolean) {
        editAvatarItem(avatarItemId: $avatarItemId, name: $name, itemType: $itemType, gender: $gender, price: $price, xOffset: $xOffset, yPos: $yPos, tiles: $tiles, photoUrls: $photoUrls, published: $published) {
            avatarItem { id name gender type price xOffset yPos published }
            errors
        }
    }
`;

export const DELETE_AVATAR_ITEM = gql`
    mutation deleteAvatarItem($avatarItemId: ID!) {
        deleteAvatarItem(avatarItemId: $avatarItemId) {
            deleted
            errors
        }
    }
`;

export const ARCHIVE_UNARCHIVE_AVATAR_ITEM = gql`
    mutation archiveUnarchiveAvatarItem($avatarItemId: ID!, $archived: Boolean!, $published: Boolean!) {
        archiveUnarchiveAvatarItem(avatarItemId: $avatarItemId, archived: $archived, published: $published) {
            avatarItem { id name gender type price xOffset yPos published }
            errors
        }
    }
`;
